"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.map.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

var _constants = require("./constants");

var runtimeVar = {
  runtimePromiseDeprecatedFlag: _constants.promiseDeprecated,
  runtimeDepsModelCollectedMap: new Map()
};
var _default = runtimeVar;
exports.default = _default;